export enum Role {
  USER = 2001,
  ADMIN = 5150,
}
export type UserStatus = 'WAITING' | 'ACTIVE';

export interface APIUser {
  user_id?: string;
  email?: string;
  name?: string;
  user_name?: string;
  organization?: string;
  status?: string;
  created_at: string;
}

export interface User {
  id: string;
  email: string;
  name: string;
  organization: string;
  status: UserStatus;
  date: Date;
}

export interface APIPendingPolicy {
  data: {
    [key: string]: {
      policy_id: string;
      content: string;
      is_accepted: boolean;
    };
  };
}

export interface PendingPolicy {
  uuid: string;
  id: string;
  title: string;
  link: string;
  content: string;
  needsApproval: boolean;
}
